const HALF_SESSION_WARNED_CUSTOM_ACTION =
    'GIL021: Se le ha mostrado al usuario que su sesion esta a la mitad en el snackbar',
  SESSION_ALMOST_WARNED_CUSTOM_ACTION =
    'GIL022: Se le ha mostrado al usuario que su sesion esta a punto de expirar en el snackbar',
  SESSION_LIMIT_TIME_REACHED_CUSTOM_ACTION =
    'GIL023: La sesion del usuario ha llegado a su limite y se le va a desconectar expirandola y sacandole error',
  SESSION_EXPIRE_NO_INIT_CUSTOM_ACTION =
    'GIL024: No existe una fecha de inicio de onboarding en el localStorage, por lo que no se puede controlar el tiempo de sesion',
  SESSION_EXPIRE_REFERENCE_REMOVED_CUSTOM_ACTION =
    'GIL203: Parece que la fecha de inicio de onboarding guardada en el almacenamiento del navegador ha sido eliminada asique no controlamos el tiempo de sesion mas.',
  SESSION_EXPIRE_INIT_CUSTOM_ACTION =
    'GIL204: Hemos configurado correctamente el proceso de vigilancia del tiempo maximo de vida de sesion de onboarding.';

export {
  HALF_SESSION_WARNED_CUSTOM_ACTION,
  SESSION_ALMOST_WARNED_CUSTOM_ACTION,
  SESSION_LIMIT_TIME_REACHED_CUSTOM_ACTION,
  SESSION_EXPIRE_NO_INIT_CUSTOM_ACTION,
  SESSION_EXPIRE_INIT_CUSTOM_ACTION,
  SESSION_EXPIRE_REFERENCE_REMOVED_CUSTOM_ACTION,
};
